import { ReactNode } from 'react';

import { MamDownload } from '~modules/downloads/MamDownload';
import { useMamAssets } from '~services/api/hooks/mam-assets.hooks';

type MamFileProps = {
  mamAssetId: number;
  description?: ReactNode;
};

export function MamFile({ mamAssetId, description }: MamFileProps) {
  const { data } = useMamAssets([mamAssetId]);

  if (data?.length) {
    const asset = data[0];
    return <MamDownload asset={asset} description={description} />;
  }

  return null;
}
